<script lang="ts" setup>
    import { ref, computed } from 'vue'

    const props = defineProps({
        voraussetzung: {
            type: String,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() =>
        props.language === 'englisch'
            ? 'Recommended prerequisites | Empfohlene Voraussetzungen'
            : 'Empfohlene Voraussetzungen'
    )

    const emit = defineEmits(['empfohleneVoraussetzungSaved'])

    let editVoraussetzung = ref('')

    function handleEditStart() {
        editVoraussetzung.value = props.voraussetzung
    }

    function handleEditAbort() {
        editVoraussetzung.value = ''
    }

    const saveVoraussetzung = () => {
        emit('empfohleneVoraussetzungSaved', editVoraussetzung.value)
    }
</script>

<template>
    <common-single-edit
        :entry="voraussetzung"
        edit-key="empfohleneVoraussetzung"
        :title="title"
        :tool-tip="tooltip"
        :allow-edit="allowEdit"
        @text-saved="saveVoraussetzung"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
    >
        <template #edit-component>
            <common-my-markup-editor v-model:content="editVoraussetzung" />
        </template>
        <template #preview-component>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="voraussetzung" />
        </template>
    </common-single-edit>
</template>

<script></script>

<style scoped lang="scss"></style>
